import { render, staticRenderFns } from "./Identification.html?vue&type=template&id=6620b2d2&scoped=true&"
import script from "./Identification.ts?vue&type=script&lang=ts&"
export * from "./Identification.ts?vue&type=script&lang=ts&"
import style0 from "./Identification.scss?vue&type=style&index=0&id=6620b2d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6620b2d2",
  null
  
)

export default component.exports